import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

declare var $: any;
declare let swal: any;
@Component({
  selector: 'app-addstockmanagement',
  templateUrl: './addstockmanagement.component.html',
  styleUrls: ['./addstockmanagement.component.css']
})
export class AddstockmanagementComponent implements OnInit {
  returnUrl = "/dashboard/stockmanagement";
  valueSelected: any;
  addStockFormValue: any;
  addgeneralFormValue: any;
  addUrl: any;
  isChecked: any;
  birthgettimerange: any;
  languages: any;
  getlistApi: any;
  unvaliddate: any = [];
  addstockUrl: any;
  statuspatch: any;
  getfarmsListData: any;
  loadspeciesValue: any;
  birthdate: any;
  loadspeciesvalue: any;
  speciesloaddata: any;
  agegrouptype: any;
  loginresponse: any;
  userrole: any;
  speciesprimaryid: any;
  ageListData: any = [];
  farm_userrole: any;
  getspeciesvalue: any = [];
  registerForm: FormGroup;
  cby_mby: any;
  submitted = false;
  getspeciesListData: any = [];

  constructor(private router: Router, private commonService: CommonService, private formBuilder: FormBuilder, private datePipe: DatePipe) { }

  async ngOnInit() {
    $('.selectpicker').selectpicker('refresh');
    var today = new Date().toISOString().split('T')[0];
    document.getElementsByName("birthdate")[0].setAttribute('max', today);
    document.getElementsByName("transferdate")[0].setAttribute('max', today);
    document.getElementsByName("purchasedate")[0].setAttribute('max', today);
    document.getElementsByName("deletiondate")[0].setAttribute('max', today);

    this.getlistApi = "/breeds";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {
        this.getspeciesListData = res.data;
      })


    this.registerForm = this.formBuilder.group({
      farmNamev: ['', Validators.required],
      speciesNamev: ['', Validators.required],
      breedNamev: ['', Validators.required],
      birthdatev: ['', Validators.required],
      agegroup: ['', Validators.required],
      animalidv: ['', Validators.required],
      gender: ['', Validators.required],
      weight: ['', Validators.required]
      // status: ['', Validators.required]      
    });

    this.loginresponse = JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole = this.loginresponse.read_status;
    this.farm_userrole = this.loginresponse.user_farm_id;
    this.cby_mby = this.loginresponse.user_id;

    if (this.farm_userrole) {
      $("#farmname").attr("disabled", "disabled")
      this.registerForm.patchValue({ farmNamev: this.farm_userrole })
    }

    this.getlistApi = "/farms";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      async (res) => {
        this.getfarmsListData = res.data;
        /* setTimeout(() => {
           $(function() {  
                  $('#farmname').multiselect({
                 
                             includeSelectAllOption: true,
                             enableFiltering: true,
                             enableCaseInsensitiveFiltering: true,
                             filterPlaceholder: 'Search for something...',
                             onChange:function(option, checked, select) {
                             this.selectedmultidata= $('#farmname').val();
                             console.log(  this.selectedmultidata);
                      
                           }
                         }); 
                 });
      }, );*/
        //farm user role based on view 
        if (this.farm_userrole) {
          setTimeout(() => {
            var optionVal = this.farm_userrole;
            console.log(this.farm_userrole);
            $("#farmname").find("option[value=" + optionVal + "]").prop("selected", "selected");

          }, 500);
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
          }, 1000);
          this.loadspeciesValue = {
            "farms_id": this.farm_userrole
          }
          // this.addUrl = "/species/farms";
          this.addUrl = "/species/list/drop_down";

          (await this.commonService.postApi(this.addUrl, this.loadspeciesValue)).subscribe(
            res => {
              this.speciesloaddata = res.data;
              console.log(this.speciesloaddata)
              setTimeout(function () {
                $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
              }, 1500);
            })

        }
        //farm user role based on view end
        setTimeout(function () {
          $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
        }, 1000);
      })
    //load species based on farms

    $('#farmname').change(async () => {
      console.log($('#farmname').val())
      var selectallvalue = $('#farmname').val();
      var farmvalue = "";
      farmvalue = selectallvalue.toString();
      this.loadspeciesValue = {
        "farms_id": farmvalue
      };
      console.log(this.loadspeciesValue.farm_id)
      //species load in select dropdown based on farm select api call
      this.addUrl = "/species/list/drop_down";
      (await this.commonService.postApi(this.addUrl, this.loadspeciesValue)).subscribe(
        res => {
          this.speciesloaddata = res.data;
          setTimeout(function () {
            $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
          }, 1000);
        })
    });
    $(document).on('change', '#farmname', function () {
      $('.myFakeClass').dropdown('toggle');
    });
    $(document).on('change', '#Speciesname', function () {
      $('.myFakeClass1').dropdown('toggle');
    });
    $(document).on('change', '#BreedName', function () {
      $('.myFakeClass2').dropdown('toggle');
    });
    $(document).on('change', '#agetype', function () {
      $('.myFakeClass3').dropdown('toggle');
    });
    $(document).on('change', '#gender', function () {
      $('.myFakeClass4').dropdown('toggle');
    });
    $(document).on('change', '#Status', function () {
      $('.myFakeClass5').dropdown('toggle');
    });


  }

  get f() { return this.registerForm.controls; }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }

    // display form values on success
    this.stockmanagement()

  }
  // display form values on success

  /* async speciesbasedonfarms(event){
    
     this.addUrl = "/species/farms/"+event.target.value;
     (await this.commonService.getApi(this.addUrl)).subscribe(
       res => {
      
            this.loadspeciesvalue=res.data;
       })
       setTimeout(function () {
         $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
      }, 1000);
   }*/
  public loadScript() {
    let body = <HTMLDivElement>document.body;
    let script = document.createElement('script');
    script.innerHTML = '';
    script.src = 'url';
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }
  deletiondateselect(e) {
    console.log(e.target.value);
    this.statuspatch = "0";
    this.registerForm.patchValue({ status: this.statuspatch })
    if (e.target.value) {
      $("#Status").val("0");
      $("#Status .filter-option-inner-inner").text("Inactive");
      $('.selectpicker').selectpicker('refresh');
    }
  }

  async breedselectbyspecies(event) {
    this.speciesprimaryid = event.target.value;
    this.addUrl = "/breeds/list/drop_down/" + this.speciesprimaryid;
    (await this.commonService.getApi(this.addUrl)).subscribe(
      res => {
        this.getspeciesvalue = res.data;
        console.log(this.getspeciesvalue);
        setTimeout(function () {
          $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
        }, 1000);
      });
  }

  

  async getdateofbirth(event) {
    const d = new Date();
    let currentdate = this.datePipe.transform(d, 'yyyy-MM-dd');
    var getdate = event.target.value;
    console.log('getdata', getdate);
    this.birthdate = getdate;
    console.log(currentdate);
    if (getdate <= currentdate) {
      this.getlistApi = "/species/age_group/filter/?dob=" + getdate + "&species_id=" + this.speciesprimaryid;
      (await this.commonService.getApi(this.getlistApi)).subscribe(
        async (res) => {
          this.ageListData = res.data;
          this.agegrouptype = res.data[0].age_group_type;
          this.birthgettimerange = res.data[0].tnag_time_range;
          // console.log(this.agegrouptype);
          console.log('ageListData', this.getlistApi)
          setTimeout(function () {
            $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
          }, 2000);
        })
    } else {
      Swal.fire("Wrong value", "Please enter valid date");
      this.unvaliddate.push('1');
    }


  }

  async stockmanagement() {
    var selectedmultidata = $('#farmname').val();
    console.log(selectedmultidata);
    //let date1, date2,date3,date4;
    if (this.agegrouptype == 1) {
      var date1 = this.birthdate;
      console.log(date1)
    }
    if (this.agegrouptype == 2) {
      var date2 = this.birthdate;
      console.log(date2)
    }
    if (this.agegrouptype == 3) {
      var date3 = this.birthdate;
      console.log(date3)
    }
    if (this.agegrouptype == 4) {
      var date4 = this.birthdate;
      console.log(date4)
    }

    this.addStockFormValue = {
      "farm_id": selectedmultidata,
      "species_id": $("#Speciesname").val(),
      "breed_id": $("#BreedName").val(),
      "age": $("#agetype").val(),
      "age_group_type": this.agegrouptype,
      "time_range": this.birthgettimerange,
      "weight": $("#getWeight").val(),
      "height": $("#getHeight").val(),
      "status": $("#Status").val(),
      "animal_code": $("#animalid").val(),
      "cby": this.cby_mby,
      "sex": $("#gender").val(),
      //"age_group_type":$("#birthdate").val(),
      "date_of_birth": $("#birthdate").val(),
      "date_of_transfer": $("#transferdate").val(),
      "date_of_purchase": $("#purchasedate").val(),
      "date_of_deletion": $("#deletiondate").val()
    };
    console.log(this.addStockFormValue)
    this.addstockUrl = "/stock_management";
    (await this.commonService.postApi(this.addstockUrl, this.addStockFormValue)).subscribe(
      data => {
        alert("Data added successfully");
        setTimeout(
          (): void => {

            this.router.navigate([this.returnUrl]);

          },
          500
        );
      },
      err => {
        Swal.fire("Duplicate values", 'Animal Id already Exist');
      });


  }
  backnavigate() {
    this.router.navigate([this.returnUrl]);
  }
}
